import type { OverWritable } from '../../@types/settings';

export const typography: OverWritable = {
  MuiTypography: {
    defaultProps: {
      ml: 0,
      variantMapping: {
        body3: 'p',
      },
    },

    styleOverrides: {
      paragraph: ({ theme }) => ({
        marginBottom: theme.spacing(2),
      }),
      gutterBottom: ({ theme }) => ({
        marginBottom: theme.spacing(1),
      }),
    },
  },
};
